import React from "react";
import { Helmet } from "react-helmet";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";

const About = () => {
  return (
    <main
      
    >
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="Discover a trusted marketplace for buying and selling digital products. Learn about our mission to empower creators and connect buyers with unique digital content."
        />
      </Helmet>
      <div>
        <AboutSection />
      </div>
      <FeaturesSection />
    </main>
  );
};

export default About;
